<template>
  <div>
    <planner-container
      v-if="clientData"
      :viewed-homes="viewedHomes"
      :have-routes="haveRoutes"
    />
    <choose-client v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isEmpty } from '../../utils/generalUtils'
import {
  feedbackNeededProperties,
  feedbackProvidedProperties
} from '../../utils/propertyUtils'
import PlannerContainer from '../../components/agent/planner/PlannerContainer.vue'
import ChooseClient from '../../components/client-detail/ChooseClient.vue'

export default {
  components: { PlannerContainer, ChooseClient },

  computed: {
    ...mapState('client', ['clientData']),
    ...mapState('agent', ['agentRouteData']),

    viewedHomes() {
      let viewedProperties = {}
      if (this.clientData && this.clientData.routes) {
        let needed = feedbackNeededProperties(
          this.clientData.homes,
          this.clientData.routes
        )
        const provided = feedbackProvidedProperties(this.clientData.homes)
        needed = needed.map(home => ({
          ...home,
          type: 'needed'
        }))
        viewedProperties = { needed, provided }
      }
      return viewedProperties
    },

    haveRoutes() {
      const clientRoutes = this.agentRouteData.filter(
        route => route.clientId === this.clientData._id
      )
      return this.clientData && !isEmpty(clientRoutes)
    }
  }
}
</script>
